export const apiGatewayEndpoint = "https://api.farrelltv.org"
export const videoStorageEndpoint = "https://videocdn.farrelltv.org"
// G-FXPY2T96NH for lab; G-7DJ0L1P09E for PROD. Update in index.html as well
// export const GA_TRACKING_ID = 'G-FXPY2T96NH'